import { render, staticRenderFns } from "./SettingFilterTab.vue?vue&type=template&id=6f830a1b&scoped=true"
import script from "./SettingFilterTab.vue?vue&type=script&lang=js"
export * from "./SettingFilterTab.vue?vue&type=script&lang=js"
import style0 from "./SettingFilterTab.vue?vue&type=style&index=0&id=6f830a1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f830a1b",
  null
  
)

export default component.exports